import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalGeneric from './ModalGeneric';

/**
 * WelcomeBackModal - Post-onboarding welcome modal
 *
 * Shown once after the user completes onboarding v2 and lands on the main app.
 * Explains the generated learning objective and how to edit it.
 */
function WelcomeBackModal({ isOpen, onClose }) {
  const { t } = useTranslation();

  return (
    <ModalGeneric
      title={t('welcome_back_modal_title', 'Welcome back!')}
      isOpen={isOpen}
      onClose={onClose}
      dismissable={true}
    >
      <div className="welcome-back-modal-body">
        <p>
          {t(
            'welcome_back_modal_description',
            "Based on your first conversation, we've created a personalized learning objective for you. You can view or edit it by tapping the map icon in the menu."
          )}
        </p>

        <div className="welcome-back-modal-tip">
          <span className="welcome-back-tip-icon" aria-hidden="true">🗺️</span>
          <span>
            {t('welcome_back_modal_tip', 'Tap the map icon to see your learning path and track your progress.')}
          </span>
        </div>

        <button
          type="button"
          className="welcome-back-modal-cta"
          onClick={onClose}
        >
          {t('continue', 'Continue')}
        </button>
      </div>
    </ModalGeneric>
  );
}

export default WelcomeBackModal;
